import { Link } from "react-router-dom";
import { ArrowLeft, ShoppingBag } from "lucide-react";
import demo from "../assests/error_404.png";

const NotFound = () => {
  return (
    <section className="min-h-screen bg-[#F7F4EF] flex items-center">

      <div className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-16 items-center">

        {/* Left */}
        <div>

          <span className="uppercase tracking-[4px] text-[#9D7D4F] text-sm">
            Error 404
          </span>

          <h1 className="font-heading text-[130px] leading-none mt-3">
            404
          </h1>

          <h2 className="font-heading text-5xl mt-3">
            Oops! This page has disappeared.
          </h2>

          <p className="text-[#6E675F] mt-6 leading-8 max-w-xl">
            The page you're looking for doesn't exist or may have been moved.
            Let's take you back to discover premium Korean skincare inspired by Seoul.
          </p>

          <div className="flex flex-wrap gap-4 mt-10">

            <Link
              to="/"
              className="flex items-center gap-2 px-8 py-4 rounded-full bg-[#1F1B18] text-white hover:bg-[#9D7D4F] duration-300"
            >
              <ArrowLeft size={18} />
              Back Home
            </Link>

            <Link
              to="/shop"
              className="flex items-center gap-2 px-8 py-4 rounded-full border border-[#1F1B18] hover:bg-[#1F1B18] hover:text-white duration-300"
            >
              <ShoppingBag size={18} />
              Shop Now
            </Link>

          </div>

        </div>

        {/* Right */}

        <div className="relative flex justify-center">

          <div className="absolute w-[420px] h-[420px] rounded-full bg-[#E7D5B8] blur-3xl opacity-70"></div>

          <img
            src={demo}
            alt="Celiora"
            className="relative w-[420px] max-w-full object-contain drop-shadow-2xl hover:scale-105 duration-500"
          />

        </div>

      </div>

    </section>
  );
};

export default NotFound;